// extracted by mini-css-extract-plugin
export default {"wrapper":"ImageFade_wrapper__SBvVb","bottomImage":"ImageFade_bottomImage__fp5ez","topImage":"ImageFade_topImage__zxgc4","placeholder":"ImageFade_placeholder__aSrrW"};